import api from '@utils/api'
import moment from 'moment'
import { sortTypes } from './constants'
import { NotificationMessage } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'

export const handleAllocationsSave = (value, directive, percentType, updateRow, setIsRefreshing, setIsExpanded) => {
  if (value === directive[percentType]) return null
  if (value < 0) {
    NotificationMessage('Allocation Percentage cannot be less than zero.', true)
    return
  }
  const floatValue = parseInt(value) / 100

  const request = {
    [percentType]: floatValue,
    curve_id: directive.curve_group_id,
  }

  api
    .updateAllocations(request)
    .then((resp) => {
      if (resp.status === 200) {
        updateRow(directive.curve_group_id, setIsRefreshing, setIsExpanded)
      }
    })
    .catch((err) => console.log(err))
}

export const handleConstraintsSave = (value, directive, key, date, updateRow, setIsRefreshing, setIsExpanded) => {
  let otherKey = 'max'
  let otherValue = directive.directive_max
  const parsedValue = parseFloat(value.replace(/,/g, ''))
  if (key === 'min') {
    if (parsedValue === directive.directive_min) return null
    if (parsedValue > directive.directive_max) {
      return NotificationMessage('Changes not saved, min must be less than max', true)
    }
  } else {
    if (parsedValue === directive.directive_max) return null
    if (parsedValue < directive.directive_min) {
      return NotificationMessage('Changes not saved, max must be greater than min', true)
    } else {
      otherKey = 'min'
      otherValue = directive.directive_min
    }
  }

  const request = {
    [key]: parsedValue,
    [otherKey]: otherValue,
    curve_group_id: directive.curve_group_id,
    as_of: moment(date).toISOString(),
  }
  api
    .updateConstraints(request)
    .then((resp) => {
      if (resp.status === 200) {
        updateRow(directive.curve_group_id, setIsRefreshing, setIsExpanded)
      }
    })
    .catch((err) => console.log(err))
}

export const grabFilterOptions = (directives, data) => {
  const terminals = grabUniqueSortedOptions(directives, 'terminal', 'terminals')
  const suppliers = grabUniqueSortedOptions(directives, 'supplier', 'suppliers')
  const products = grabUniqueSortedOptions(directives, 'product', 'products')

  return {
    terminals,
    suppliers,
    products,
    supplyZones: data.supply_zones,
  }
}
export const grabDates = (selectedDate) => {
  const isCurrentMonth = moment(selectedDate).isSame(new Date(), 'month')
  if (isCurrentMonth && moment(selectedDate).isAfter(moment().endOf('day'))) {
    return {
      as_of: moment().startOf('day').add(10, 'minutes').toISOString(),
      future_date: moment(selectedDate).startOf('day').add(10, 'minutes').toISOString(),
    }
  }
  return { as_of: selectedDate.toISOString() }
}
export const filterDirectives = (filters, unfilteredDirectives, viewingPlanned = true) => {
  let filteredList = [...unfilteredDirectives]
  const deltaKey = viewingPlanned ? 'delta_to_directive' : 'delta_without_planned'
  const foundEm = (directive, name, plural) => {
    const singleItem = filters[plural].includes(directive[name])
    const isInMulti = directive[plural].some((item) => filters[plural].includes(item))
    return singleItem || isInMulti
  }

  if (filters.suppliers && filters.suppliers.length !== 0) {
    filteredList = filteredList.filter((directive) => foundEm(directive, 'supplier', 'suppliers'))
  }
  if (filters.terminals && filters.terminals.length !== 0) {
    filteredList = filteredList.filter((directive) => foundEm(directive, 'terminal', 'terminals'))
  }
  if (filters.products && filters.products?.length !== 0) {
    filteredList = filteredList.filter((directive) => foundEm(directive, 'product', 'products'))
  }
  if (filters.status === 'outside') {
    filteredList = filteredList.filter((directive) => directive[deltaKey] !== 0)
  }
  if (filters.status === 'over') {
    filteredList = filteredList.filter((directive) => directive[deltaKey] > 0)
  }
  if (filters.status === 'under') {
    filteredList = filteredList.filter((directive) => directive[deltaKey] < 0)
  }
  return filteredList
}
export const generateChartData = (volumes, min, max) => {
  const barData = []
  let runningTotal = 0
  volumes.forEach((bar) => {
    const barDate = formatters.CHART_DAY_HOUR(bar.date, bar.date_local)
    runningTotal += bar.loaded + bar.scheduled
    const newBar = {
      loaded: bar.loaded,
      scheduled: bar.scheduled,
      total: runningTotal,
      date: barDate,
    }
    barData.push(newBar)
  })

  return {
    volumes: barData,
    directiveMin: min,
    directiveMax: max,
  }
}
export const insertRow = (updatedRow, unfilteredList, filteredList, setUnfilteredList, setFilteredList) => {
  const unfilteredCopy = [...unfilteredList]
  const filteredCopy = [...filteredList]
  const unfilteredMatchIndex = unfilteredCopy.findIndex((row) => row.curve_group_id === updatedRow.curve_group_id)
  const filteredIndex = filteredCopy.findIndex((row) => row.curve_group_id === updatedRow.curve_group_id)
  unfilteredCopy[unfilteredMatchIndex] = { ...updatedRow }
  filteredCopy[filteredIndex] = { ...updatedRow }
  setUnfilteredList(unfilteredCopy)
  setFilteredList(filteredCopy)
}
export const sortDirectives = (directives, activeSort, sortDirection) => {
  const sortedDirectives = [...directives]
  const sortConfig = sortTypes[activeSort.toUpperCase()]
  if (sortDirection === 'asc') {
    return sortedDirectives.sort(sortConfig.sorter)
  }
  return sortedDirectives.reverse()
}
// /////////////////////////////////// SUPPORTING

const grabUniqueSortedOptions = (list, nameField, plural) =>
  [
    ...new Set(
      list.reduce(
        (acc, directive) =>
          directive[nameField]
            ? [...acc, directive[nameField]]
            : [...acc, ...directive[plural].map((product) => product)],
        []
      )
    ),
  ]
    .sort()
    .map((item) => ({ id: item, name: item }))

// Jim was here
const directiveDayStartOffset = 60 * 4 + 10 // EST -> PST (4 Hours + 10 minutes) to make sure we're within the day.

export const getDirectiveDayStartUTC = (dateString) =>
  moment(dateString).startOf('day').add(directiveDayStartOffset, 'minutes')
